if not App.angularApp?
    return

App.angularApp.directive 'stopEvent', () ->
    return {
        link: (scope, element, attr) ->
            element.bind 'click', (e) ->
                e.stopPropagation()
    }
